export const name = 're-reset-password'

// generic setup
import {allValidationsRules as validationsRules, defaultFormFields} from './form'

import props from './props'

export {props, validationsRules, defaultFormFields}

import ComponentMixin from '../../../../mixins/components/complex'
import FormMixin from '../../../../mixins/form'
import FormForceUpdateMixin from '../../../../mixins/form/force-update-onload'
export const mixins = [ComponentMixin, FormMixin, FormForceUpdateMixin]

export const EventBus = window.VueEventBus

// data
const propDefs = props
export const data = {
  propDefs
}

export default {
  name,
  mixins,
  props,
  data,

  validationsRules,
  defaultFormFields,

  EventBus
}
